import { render, staticRenderFns } from "./ShipmentConfirmation.vue?vue&type=template&id=19fee24c&"
import script from "./ShipmentConfirmation.vue?vue&type=script&lang=js&"
export * from "./ShipmentConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentConfirmation.vue?vue&type=style&index=0&id=19fee24c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports